// Mirrors API validation in
// `wanderfit-api/src/financial/payouts/infrastructure/admin-catalog.dto.ts`.
// Keep these in sync — the server enforces them; the client just gives
// faster feedback before hitting Stripe.
export const PRODUCT_NAME_MAX_LENGTH = 250;
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 500;
export const TAX_RATE_DISPLAY_NAME_MAX_LENGTH = 250;
export const TAX_RATE_JURISDICTION_MAX_LENGTH = 100;
export const TAX_RATE_DESCRIPTION_MAX_LENGTH = 500;

// Stripe accepts unitAmount as the smallest currency unit (cents for USD)
// up to ~$999,999.99. Matches the API DTO bound.
export const PRICE_UNIT_AMOUNT_MAX = 99_999_999;

export const PRICE_LOOKUP_KEY_MAX_LENGTH = 50;
export const PRICE_LOOKUP_KEY_REGEX = /^[a-z][a-z0-9_]{0,49}$/;
export const PRICE_CURRENCY_REGEX = /^[a-z]{3}$/;

// ── Pricing-v2 product metadata ────────────────────────────────────
// pricing-v2 turned the Stripe Product into the tier anchor. Three
// metadata keys drive the public catalog + switch-plan classifier:
//   • `tier`   — FIT | FITTER | FITTEST. A Product without a valid
//                tier is silently excluded from the public catalog.
//   • `access` — CSV of venue types the tier unlocks (drives passes /
//                scan eligibility). Current vocabulary: gym, spa.
//   • `rank`   — integer; orders tiers for the switch-plan classifier.
//                Convention 10/20/30, gaps left for future tiers.
// Mirrors `wanderfit-api` `product-catalog.port.ts` (`PRODUCT_METADATA_*_KEY`).
export const PRODUCT_METADATA_TIER_KEY = "tier";
export const PRODUCT_METADATA_ACCESS_KEY = "access";
export const PRODUCT_METADATA_RANK_KEY = "rank";

// CAPACITY-PIVOT FOLLOW-UP (deferred — see docs/planning/capacity-pivot-bo.md
// §4 "B3"): tiers are now first-class rows in `subscription_tiers` (keys like
// `TIER_1`), linked to a Stripe Product via `stripeProductId`. This legacy
// `metadata.tier` (FIT/FITTER/FITTEST) is a DIFFERENT identifier — the backend
// still reads it as a fallback while Products are unlinked, so DO NOT remove it
// yet. Retire this metadata-tier UI only after the tier ABM + Product↔tier
// linking ship and live Products are linked.
export const PRODUCT_TIERS = ["FIT", "FITTER", "FITTEST"] as const;
export type ProductTier = (typeof PRODUCT_TIERS)[number];

// `access` is a free-form CSV on the API side; the backoffice offers the
// known vocabulary (derived from the API `VenueType` enum: GYM, SPA).
export const PRODUCT_ACCESS_OPTIONS = ["gym", "spa"] as const;
export type ProductAccess = (typeof PRODUCT_ACCESS_OPTIONS)[number];

export const PRODUCT_RANK_MIN = 1;
export const PRODUCT_RANK_MAX = 100_000;
